import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCustomerCustomFieldsResponse } from '@/api/agency/customers/get-customer-custom-fields'

export const mockGetCustomerCustomFields = http.get(
  '/my-business/api/agency/v1/customers/:customerId/custom-fields',
  () => {
    const data: GetCustomerCustomFieldsResponse = {
      data: Array.from({ length: 4 }).map(() => ({
        active: true,
        alphaId: faker.string.uuid(),
        alphanumeric: faker.datatype.boolean(),
        companyCustomFieldTypeId: faker.number.int({ min: 1, max: 10 }),
        mandatory: faker.datatype.boolean(),
        name: faker.lorem.words(3),
        optionList: faker.lorem.word().concat(';').concat(faker.lorem.word()),
      })),
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
